import { Box, type BoxProps } from '@mantine/core'
import React from 'react'

import { AlertActionableActions } from './components/Actions'
import { AlertActionableDescription } from './components/Description'
import { AlertActionableTitle } from './components/Title'
import classes from './styles.module.css'

export function AlertActionable({
  children,
  ...props
}: React.PropsWithChildren<BoxProps>) {
  return (
    <Box className={classes.container} {...props}>
      {children}
    </Box>
  )
}

AlertActionable.Title = AlertActionableTitle
AlertActionable.Description = AlertActionableDescription
AlertActionable.Actions = AlertActionableActions
